
import { getChainID } from "@/decentralizedApi/inits";
import { blockScans } from '@/decentralizedApi/customNetwork';

export const getCurentChainScans = () => blockScans[getChainID()];

export const viewHash = hash => {
  window.open(`${getCurentChainScans()}/tx/` + hash);
};

export const viewToken = address => {
  window.open(`${getCurentChainScans()}/token/` + address);
};

export const addToken = async address => {
  const tokenAddress = address;
  const tokenSymbol = 'BIGSWAP-LP';
  const tokenDecimals = 18;
  const tokenImage = '';
  try {
    // wasAdded is a boolean. Like any RPC method, an error may be thrown.
    const wasAdded = await window.ethereum.request({
      method: 'wallet_watchAsset',
      params: {
        type: 'ERC20', // Initially only supports ERC20, but eventually more!
        options: {
          address: tokenAddress, // The address that the token is at.
          symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
          decimals: tokenDecimals, // The number of decimals in the token
          image: tokenImage, // A string url of the token logo
        },
      },
    });

    if (wasAdded) {
      console.log('Thanks for your interest!');
    } else {
      console.log('Your loss!');
    }
  } catch (error) {
    console.log(error);
  }
};